<template>
  <article class="example-page">
    <notification />
    <h1>Notification</h1>
    <form>
      <label for="notification-content">Content</label>
      <input id="notification-content" v-model="content" type="text">
      <button type="button" @click="toggle">Trigger Notification!</button>
    </form>
  </article>
</template>

<script>
import { mapActions } from '@/lib/vue';
import { notification } from '@/components/layout';

export default {
  components: { notification },
  data() {
    return {
      content: 'This is an alert!!',
    };
  },
  methods: {
    ...mapActions(['showNotification']),
    toggle() {
      this.showNotification({ icon: '/images/tada.png', message: this.content });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
